// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ILinkVerificationCodeValidationRequestDto
 */
export interface ILinkVerificationCodeValidationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ILinkVerificationCodeValidationRequestDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof ILinkVerificationCodeValidationRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ILinkVerificationCodeValidationRequestDto
     */
    hash_id: string;
}

/**
 * Check if a given object implements the ILinkVerificationCodeValidationRequestDto interface.
 */
export function instanceOfILinkVerificationCodeValidationRequestDto(value: object): value is ILinkVerificationCodeValidationRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('hash_id' in value) || value['hash_id'] === undefined) return false;
    return true;
}

export function ILinkVerificationCodeValidationRequestDtoFromJSON(json: any): ILinkVerificationCodeValidationRequestDto {
    return ILinkVerificationCodeValidationRequestDtoFromJSONTyped(json, false);
}

export function ILinkVerificationCodeValidationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILinkVerificationCodeValidationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'email': json['email'],
        'hash_id': json['hash_id'],
    };
}

export function ILinkVerificationCodeValidationRequestDtoToJSON(json: any): ILinkVerificationCodeValidationRequestDto {
    return ILinkVerificationCodeValidationRequestDtoToJSONTyped(json, false);
}

export function ILinkVerificationCodeValidationRequestDtoToJSONTyped(value?: ILinkVerificationCodeValidationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'email': value['email'],
        'hash_id': value['hash_id'],
    };
}

